var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 488,
    height: 328
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_990_54795_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 479,
    height: 319,
    rx: 19.5,
    stroke: "#ACACAC",
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.334 138.667C229.334 137.194 230.436 136 231.796 136H248.206C249.565 136 250.667 137.194 250.667 138.667C250.667 140.139 249.565 141.333 248.206 141.333H231.796C230.436 141.333 229.334 140.139 229.334 138.667Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.075 184H245.927C254.249 184 258.411 184 261.4 182.074C262.694 181.24 263.805 180.169 264.67 178.921C266.667 176.038 266.667 172.025 266.667 164C266.667 155.974 266.667 151.962 264.669 149.079C263.805 147.831 262.694 146.76 261.4 145.926C258.41 144 254.249 144 245.926 144H234.074C225.752 144 221.59 144 218.601 145.926C217.307 146.76 216.196 147.831 215.331 149.079C213.334 151.961 213.334 155.972 213.334 163.994V164C213.334 172.025 213.334 176.038 215.331 178.921C216.196 180.169 217.307 181.24 218.601 182.074C221.591 184 225.752 184 234.075 184ZM228.89 164C228.89 158.082 233.864 153.285 240.001 153.285C246.137 153.285 251.112 158.082 251.112 164C251.112 169.917 246.137 174.714 240.001 174.714C233.864 174.714 228.89 169.917 228.89 164ZM233.334 164C233.334 160.449 236.319 157.571 240.001 157.571C243.683 157.571 246.667 160.449 246.667 164C246.667 167.55 243.683 170.428 240.001 170.428C236.319 170.428 233.334 167.55 233.334 164ZM256.297 153.285C255.07 153.285 254.075 154.245 254.075 155.428C254.075 156.612 255.07 157.571 256.297 157.571H257.779C259.006 157.571 260.001 156.612 260.001 155.428C260.001 154.245 259.006 153.285 257.779 153.285H256.297Z",
    fill: "#ACACAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_990_54795_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 479,
    height: 319,
    rx: 19.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoUpload);
export default __webpack_public_path__ + "static/media/photo_upload.bba15d96498f671d055a6a4c052d347a.svg";
export { ForwardRef as ReactComponent };